/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { updateAlbumTrackOrderBodySchema } from "../updateAlbumTrackOrderBodySchema.ts";
import { z } from "zod";

export const putApiAlbumsIdTracksOrderPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор альбома.")
    })

/**
 * @description Порядок изменен
 */
export const putApiAlbumsIdTracksOrder200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const putApiAlbumsIdTracksOrder400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiAlbumsIdTracksOrder401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiAlbumsIdTracksOrder403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Альбом не найден | Треки не найдены
 */
export const putApiAlbumsIdTracksOrder404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiAlbumsIdTracksOrder500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Список идентификаторов треков с порядком.
 */
export const putApiAlbumsIdTracksOrderMutationRequestSchema = z.array(z.lazy(() => updateAlbumTrackOrderBodySchema)).describe("Список идентификаторов треков с порядком.")

export const putApiAlbumsIdTracksOrderMutationResponseSchema = z.lazy(() => putApiAlbumsIdTracksOrder200Schema)